<template>
  <div>
    <el-button
      size="mini"
      :disabled="!selectedSaleIds.length && !selectedRepresentativeSaleIds.length"
      type="success"
      style="margin-bottom: 20px"
      @click="createInvoice"
    >
      Számla készítés
    </el-button>
    <el-date-picker
      v-model="filterDateRange"
      ref="range"
      type="daterange"
      format="yyyy. MM. dd."
      value-format="yyyy-MM-dd"
      :picker-options="{ firstDayOfWeek: 1 }"
      style="width: 70%; margin-bottom: 20px; margin-left: 20px"
      @change="onDateChange"
      size="mini"
    />
    <el-table
      :data="sales"
      width="100%"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        prop="receipt_number"
        label="Bizonylatszám"
      >
        <template slot-scope="props">
          {{ props.row.receipt_number }}
        </template>
      </el-table-column>
      <el-table-column
        prop="delivery_date"
        label="Teljesítés dátuma"
      >
        <template slot-scope="props">
          {{ props.row.delivery_date | date }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
  import moment from 'moment';

  export default {
    props: ['billableSales', 'customerId'],

    data() {
      return {
        sales: [],
        selectedSaleIds: [],
        selectedRepresentativeSaleIds: [],
        filterDateRange: [],
      }
    },

    mounted() {
      this.sales = this.billableSales;
    },

    methods: {
      onDateChange(dates) {
        if(dates && dates.length) {
          this.sales = this.billableSales.filter(sale => moment(sale.delivery_date).isBetween(moment(dates[0]), moment(dates[1])));
        } else {
          this.sales = this.billableSales;
        }
      },
      handleSelectionChange(values) {
        this.selectedSaleIds = values.filter(v => v.type === 'customerSale').map(val => val.id);
        this.selectedRepresentativeSaleIds = values.filter(v => v.type === 'representativeSale').map(val => val.id);
      },

      createInvoice() {
        this.$emit('createInvoice', {
          customerId: this.customerId,
          selectedSaleIds: this.selectedSaleIds,
          selectedRepresentativeSaleIds: this.selectedRepresentativeSaleIds,
        })
      }
    },
  }
</script>
